import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TenantUsagePage } from "@/features/tenant/UsagePage";

export const Route = createFileRoute("/app/tenant/usage")({
  validateSearch: z.object({ tab: z.enum(["traffic", "billable"]).optional().catch(undefined) }),
  component: TenantUsagePage,
});
